/**
 * The inline style for a fan's initials plate on the web (ISSUE-1111).
 *
 * The color comes from the display name through `@sportsmet/theme`'s
 * `avatarPlateForName`. It is inline because the fill is picked per fan at run
 * time and no CSS variable exists for it. Pass the fan's display name, never
 * their initials.
 */
import { avatarPlateForName } from "@sportsmet/theme";

export type typeAvatarPlateStyle = {
  backgroundColor: string;
  color: string;
};

export function avatarPlateStyle(displayName: string): typeAvatarPlateStyle {
  const plate = avatarPlateForName(displayName);
  return { backgroundColor: plate.fill, color: plate.on };
}
